import { render, staticRenderFns } from "./OperationalLogs.vue?vue&type=template&id=045660e2&scoped=true"
import script from "./OperationalLogs.vue?vue&type=script&lang=js"
export * from "./OperationalLogs.vue?vue&type=script&lang=js"
import style0 from "./OperationalLogs.vue?vue&type=style&index=0&id=045660e2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045660e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045660e2')) {
      api.createRecord('045660e2', component.options)
    } else {
      api.reload('045660e2', component.options)
    }
    module.hot.accept("./OperationalLogs.vue?vue&type=template&id=045660e2&scoped=true", function () {
      api.rerender('045660e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/detailComponent/OperateLogs/OperationalLogs.vue"
export default component.exports